<template>
<section class="section is-size-7">
  <!--<b-loading :is-full-page=false :active.sync="isLoadingRefresh" :can-cancel="true"></b-loading>-->

  <div class="card">
    <header class="card-header has-background-white-ter label is-size-6">
      <p class="card-header-title">
        <strong>
          <h2>User Dashboard</h2>
        </strong>
      </p>
      <p class="card-header-icon is-pulled-right">
        <b-tooltip label="Refresh" position="is-left" type="is-primary">
            <button type="button" name="button" @click="getMainData()" class="button is-rounded is-small has-background-white-ter" :class="{'is-loading click-not-allowed':isLoadingRefresh}">
              <!--<b-icon class="is-small" icon="refresh"></b-icon>-->
            </button>
        </b-tooltip>
      </p>
    </header>
    <div class="">
      <div class="columns sidespace">
        <div class="column">
          <label class="label is-small">Process</label>
          <div class="field">
          <div class="select is-small is-fullwidth">
            <select v-model="filter.subdepartmentid" required @change="getTlList()">
                 <option :value="d.subdepartmentid" v-for="(d,index) in subDepartmentList" :key="index">{{d.subdeptname}}</option>
            </select>
          </div>
        </div>
      </div>
        <div class="column">
            <label class="label is-small">Location</label>
            <div class="field">
            <div class="select is-small is-fullwidth">
              <select v-if="isLocationDisabled" disabled>
                <option class="is-capitalized">
                  {{filter.location.location}}
                </option>
            </select>
              <select v-model="filter.location" required @change="getTlList()" v-else>
                <option value="">--Select--</option>
                <option :value="l" v-for="(l,index) in locations" :key="index" class="is-capitalized">{{l.location}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label is-small">Team Lead</label>
            <div class="control">
              <div class="select is-fullwidth is-small">
                <select v-model="tlemailid" @change="getAgents()" :disabled="disableTl">
                  <option value="" selected>All</option>
                  <option :value="tl.email" v-for="(tl,index) in tlMaster" :key="index">{{tl.email}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="field">
            <label class="label is-small">Agent</label>
            <div class="control">
              <div class="select is-fullwidth is-small">
                <select v-model="agentemailid" @change="getMainData()">
                  <option value="" selected>All</option>
                  <option :value="agent.email" v-for="(agent,index) in agentMaster" :key="index">{{agent.email}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="field">
            <label class="label is-small">Agent Status</label>
            <div class="control">
              <div class="select is-fullwidth is-small">
                <select v-model="agentestatus" @change="getMainData()">
                  <option value="" selected>All</option>
                  <option :value="status.value" v-for="(status,index) in agentStatusList" :key="index">{{status.name}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="columns">
        <div class="column is-fullwidth sidespace">
          <b-table class="custom_table colWidth" :data="tableData" :striped="true" v-if="tableData.length">
            <template slot-scope="props">
              <b-table-column field="handler" label="Handler Name">
                {{ props.row.handler }}
              </b-table-column>
              <b-table-column field="allocated" label="Allocated" class="has-text-centered" >
                <router-link v-bind:class="(props.row.allocated && !disableCountClick) ? 'has-text-black-bis' : 'click-not-allowed has-text-black-bis'" target="_self" title="Allocated Cases"
                :to="{ path: '/emailr/emailtracking', query: { subdepartmentid:filter.subdepartmentid,status:'allocated',toDate:SendDate.toDate,agentemail:props.row.handler,tlemail:tlemailid}}">
                  {{ props.row.allocated }}
                </router-link>
              </b-table-column>
              <b-table-column field="inprocess" label="In Process" class="has-text-centered" >
                <router-link v-bind:class="(props.row.inprocess && !disableCountClick) ? 'has-text-black-bis' : 'click-not-allowed has-text-black-bis'" target="_self" title="In Process Cases"
                :to="{ path: '/emailr/emailtracking', query: { subdepartmentid:filter.subdepartmentid,status:'inprocess',toDate:SendDate.toDate,agentemail:props.row.handler,tlemail:tlemailid}}">
                  {{ props.row.inprocess }}
                </router-link>
              </b-table-column>
              <b-table-column field="closed" label="Closed" class="has-text-centered" >
                <router-link v-bind:class="(props.row.closed && !disableCountClick) ? 'has-text-black-bis' : 'click-not-allowed has-text-black-bis'" target="_self" title="Closed Cases"
                :to="{ path: '/emailr/emailtracking',query: { subdepartmentid:filter.subdepartmentid,status:'close',fromDate:SendDate.fromDate,toDate:SendDate.toDate,agentemail:props.row.handler,tlemail:tlemailid}}">
                  {{ props.row.closed }}
                </router-link>
              </b-table-column>
              <b-table-column field="spam" label="Spam" class="has-text-centered" >
                <router-link v-bind:class="(props.row.spam && !disableCountClick) ? 'has-text-black-bis' : 'click-not-allowed has-text-black-bis'" target="_self" title="Spam Cases"
                :to="{ path: '/emailr/emailtracking', query: { subdepartmentid:filter.subdepartmentid,status:'Spam',fromDate:SendDate.fromDate,toDate:SendDate.toDate,agentemail:props.row.handler,tlemail:tlemailid}}">
                  {{ props.row.spam }}
                </router-link>
              </b-table-column>
              <!-- <b-table-column field="parked" label="Logistics" class="has-text-centered" >
                <router-link v-bind:class="(props.row.parked && !disableCountClick) ? 'has-text-black-bis' : 'click-not-allowed has-text-black-bis'" target="_self" title="Logistics"
                :to="{ path: '/emailr/emailtracking',query: { status:'parked',fromDate:SendDate.last60FromDate,toDate:SendDate.toDate,agentemail:props.row.handler}}">
                  {{ props.row.parked }}
                </router-link>
              </b-table-column> -->
              <b-table-column field="status" label="Agent Status" class="has-text-centered" >
                {{ props.row.status || '-'}}
              </b-table-column>
              <b-table-column  class="has-text-centered" field="statusduration" label="Agent Status Duration" :style="{ 'background-color':checkMins(props.row.statusduration) }">
                <span style="color: #fff">{{ props.row.statusduration }}</span>
              </b-table-column>
              <b-table-column field="outcallcount" label="Total Out Calls Made" class="has-text-centered" >
                {{ props.row.outcallcount ||'-'}}
              </b-table-column>
              <b-table-column field="rnf" label="R&F" centered>
                <span class="padding" v-if="props.row.status && props.row.status.toLowerCase() === 'idle'"><!-- Show R if status=Idle -->
                  <b-tooltip :label="disableCountClick ? disabledMsg : 'Click to R&F'" type="is-dark">
                    <button class="button is-small is-outlined is-primary" @click="getIvrReasonList(props.row.handler, props.row.userid, 2, props.row.ispaused)"
                     :disabled="disableCountClick">R</button>
                  </b-tooltip>
                </span>
                <!-- Pause -->
                <span class="padding" v-if="props.row.inqueue && props.row.ispaused"><!-- Show if User is in Queue -->
                  <b-tooltip :label="disableCountClick ? disabledMsg : 'Click to Un-pause'" type="is-dark">
                    <button class="button is-small is-warning" @click="getIvrReasonList(props.row.handler, props.row.userid, 3, props.row.ispaused)"
                     :disabled="disableCountClick">P</button>
                  </b-tooltip>
                </span>
                <span class="padding" v-else-if="props.row.inqueue && !props.row.ispaused">
                  <b-tooltip :label="disableCountClick ? disabledMsg : 'Click to Pause'" type="is-dark">
                    <button class="button is-small is-primary" @click="getIvrReasonList(props.row.handler, props.row.userid, 3, props.row.ispaused)"
                     :disabled="disableCountClick">P</button>
                  </b-tooltip>
                </span>
                <!-- <span v-else>
                  <span class="tag is-info">NotInQueue</span>
                </span> -->
                <!-- // Pause -->
              </b-table-column>
              <b-table-column field="breaktime" label="Total Break for the Day" class="has-text-centered" >
                <span :class="{'text-red': checkHour(props.row.breaktime)}">{{ props.row.breaktime || '-'}}</span>
              </b-table-column>
            </template>
          </b-table>
          <br>
          <div class="is-size-7 has-text-centered no_record" v-if="!tableData.length">
             <p class="content has-text-grey"> <b-icon icon="alert-decagram"></b-icon> &nbsp; <span class="is-size-6">No Records Found </span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Reason model -->
  <div class="modal" :class="{'is-active':isReasonModal}">
    <div class="modal-background"></div>
    <div class="modal-card search-modal">
      <header class="modal-card-head">
        <p class="modal-card-title" v-if="reasontype === 2">R&F Reasons</p>
        <p class="modal-card-title" v-if="reasontype === 3">Pause Reasons</p>
        <button type="button" class="delete has-background-danger" @click="toggleReasonModal"></button>
      </header>
      <form @submit.prevent="submitReason()">
        <section class="modal-card-body">
          <div class="columns is-multiline is-mobile">
            <div class="column">
              <div class="field">
                <label class="label is-small">Reason</label>
                <div class="control">
                  <div class="select is-fullwidth is-small">
                    <select v-model="reasontypeid" class="is-capitalized" @change="toggleCommentbox()" required>
                      <option value="" selected>--Select--</option>
                      <option :value="reason.ReasonID" v-for="(reason,index) in reasonList" :key="index">{{reason.ReasonText}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column" v-if="isCommentboxShow">
              <div class="field">
                <label class="label is-small">Comment</label>
                <div class="control" cols="12">
                  <textarea size="sm" class="input is-small" placeholder="Enter comment..." v-model.trim="comment" :require="isCommentRequired" :disabled="isCommentboxDisable"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
          <div class="column m-t-20">
            <div class="is-pulled-right">
                <button type="submit" class="button is-small is-primary" variant="primary" size="sm">Done</button>
            </div>
          </div>
        </div>
        </section>
      </form>
    </div>
  </div>
  <!-- //Reason model -->
</section>
</template>

<script>
//import CONSTANTS from '@/utils/constants'
//import stores from '@/stores'
import moment from 'moment'
//import io from 'socket.io-client'
//import EmailrCommonFunctions from '@/components/Emailr/EmailrCommonFunctions'

export default {
  name: 'userdashboard',
  data () {
    return {
      date: new Date(),
      SendDate: {
        fromDate: moment(this.date).format('YYYY-MM-DD'),
        toDate: moment(this.date).format('YYYY-MM-DD')
      },
      loadingComponent: null,
      tableData: [],
      disableTl: false,
      tlMaster: [],
      tlemailid: '',
      agentMaster: [],
      agentemailid: '',
      agentestatus: '',
      agentStatusList: [
        { value: 'Short Break', name: 'Short Break' },
        { value: 'Long Break', name: 'Long Break' },
        { value: 'Logout', name: 'Logout' },
        { value: 'Unavailable', name: 'Unavailable' },
        { value: 'Idle', name: 'Idle' },
        { value: 'On Call', name: 'On Call' },
        { value: 'On Hold', name: 'On Hold' },
        { value: 'Ringing', name: 'Ringing' },
        { value: 'ACW', name: 'ACW' },
        { value: 'R & F', name: 'R & F' },
        { value: 'Unreachable', name: 'Unreachable' }
      ],
      // Reason update modal
      isReasonModal: false,
      reasontype: '',
      reasontypeid: '',
      reasonList: [],
      comment: '',
      ivrAgent: '',
      ivrAgentUserid: '',
      isPaused: '',
      isCommentboxDisable: true,
      isCommentboxShow: true,
      isCommentRequired: false,
      timer: '',
      disableCountClick: true,
      isLoadingRefresh: false,
      filter: {
        subdepartmentid: '',
        location: {
          location:'',
          locationid:''
        }
      },
      subDepartmentList: [],
      disabledMsg: '',
      isLocationDisabled: false,
      locations: []
    }
  },
  created () {
    /*this.loggedUser = stores.user.getLoggedinUserData()
    let perm = stores.user.hasPermission('/emailr/userdashboard', 'Read')
    if (!perm) {
      this.$router.push({ path: '/' })
      return this.$buefy.toast.open({
        message: 'You do not have access to this page.',
        type: 'is-danger'
      })
    }
    this.subDepartmentList = this.loggedUser.subdepartment.filter((m) => {
      if ((m.subdeptname) && (m.subdeptname.toLowerCase() === 'ccemail' || m.subdeptname.toLowerCase() === 'babyhugemail')) {
        this.filter.subdepartmentid = m.subdepartmentid
        return m
      }
    })
    this.enableTlddl()
    */
  },
  methods: {
    getAllTeamLead: async function () {
      try {
        this.tlMaster = await EmailrCommonFunctions.getTLbysubdept(this.filter.subdepartmentid, this.loggedUser.systemId,this.filter.location,'ivr')
        if (this.tlMaster && this.tlMaster.length) {
          this.tlMaster.filter((user)=>{
            if (user.email && this.loggedUser.emailaddress && user.email.toLowerCase() === this.loggedUser.emailaddress.toLowerCase()) {
              this.tlemailid = user.email
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    enableTlddl: async function () {
      this.agentemailid = ''
      this.agentMaster = []
        if (this.filter.subdepartmentid) {
          if (this.loggedUser.role.toLowerCase() === 'teamlead') {
            this.isLocationDisabled = false
            this.tlMaster.push({
              email: this.loggedUser.emailaddress,
              userid: this.loggedUser.userid
            })
            this.tlemailid = this.loggedUser.emailaddress
            await this.getAllActiveLocations()
            this.getAllTeamLead()
            await this.getAgents()
            this.disableAgent = false
            this.disableAgentStatus = false
          } else {
            await this.getAllActiveLocations()
            this.disabledMsg = 'Please select TL'
            if (this.filter.location && this.filter.location.locationid) {
              await this.getTlList()
              this.disableTl = false
            } else {
              return this.$buefy.toast.open({
                message: 'Please select location.',
                type: 'is-danger'
              })
            }
          }
        } else {
          this.disabledMsg = 'Please select subdepartment'
          this.disableTl = true
          this.disableAgent = true
          this.disableCountClick = true
          this.disableAgentStatus = true
        }
    },
    getTlList: function () {
      if (this.loggedUser.role.toLowerCase() === 'teamlead') {
        this.isLoadingRefresh = true
        this.getAllTeamLead()
        this.isLoadingRefresh = false
        if (this.tlMaster.length) {
          this.getAgents()
        } else {
          return this.$buefy.toast.open({
            message: `No TL data found`,
            type: 'is-danger'
          })
        }
      } else {
        this.tlMaster = []
        this.agentMaster = []
        this.agentemailid = ''
        this.tableData = []
        if (this.filter.location && this.filter.location.locationid) {
          let getRoleObj = {
            rolename: 'teamlead',
            emailaddress: this.loggedUser.emailaddress,
            subdepartmentid: this.filter.subdepartmentid,
            systemid: this.loggedUser.systemId,
            locationid: this.filter.location.locationid
          }
          this.isLoadingRefresh = true
          return http.get(`${CONSTANTS.API_URL}/api/get/supervisor/feedbackrole`, getRoleObj)
            .then((result) => {
              if (result && result.data.length) {
                this.disableTl = false // enable TL ddl
                this.tlMaster = result.data.map(agent => ({ email: agent.emailaddress, userid: agent.userid }))
                this.getAgents()
              } else {
                return this.$buefy.toast.open({
                  message: `No TL data found`,
                  type: 'is-danger'
                })
              }
              this.isLoadingRefresh = false
            })
            .catch((HTTPException) => {
              this.isLoadingRefresh = false
              return this.$buefy.toast.open({
                message: HTTPException.message,
                type: 'is-danger'
              })
            })
        } else {
          return this.$buefy.toast.open({
            message: 'Please select location.',
            type: 'is-danger'
          })
        }
      }
    },
    getAgents: function () {
      this.agentMaster = []
      this.agentemailid = ''
      let emailArr = []
      if (!this.tlemailid) { // for all TLs
        emailArr = this.tlMaster.map(each => each.email)
        this.disableAgent = true
        this.disableAgentStatus = true
        this.disableCountClick = true
      } else { // for selected TL
        emailArr.push(this.tlemailid)
        this.disableAgent = false
        this.disableAgentStatus = false
        this.disableCountClick = false
      }
      let getAgentObj = {
        systemid: this.loggedUser.systemId,
        emailaddress: emailArr,
        isactive: 'true',
        subdepartmentid: this.filter.subdepartmentid
      }
      Object.keys(getAgentObj).forEach((key) => {
        if (getAgentObj[key] === '' || getAgentObj[key] === null || getAgentObj[key] === undefined) {
          delete getAgentObj[key]
        }
      })
      return http.post(`${CONSTANTS.API_URL}/api/usermgt/getagentinbulk`, getAgentObj)
        .then(result => {
          if (result && result.data.length) {
            this.agentMaster = result.data.map(agent => ({
              email: agent.userroledetail.usermaster.emailaddress,
              userid: agent.userroledetail.usermaster.userid,
              location: agent.userroledetail.usermaster.location || ''
            }))
            this.getMainData()
          } else {
            return this.$buefy.toast.open({
              message: `No agents found`,
              type: 'is-danger'
            })
          }
        }).catch((httpException) => {
          return this.$buefy.toast.open({
            message: httpException.message,
            type: 'is-danger'
          })
        })
    },
    getMainData: function () {
      if (!this.filter.location.location) {
        return this.$buefy.toast.open({
          message: 'Please select location.',
          type: 'is-danger'
        })
      }
      this.isLoadingRefresh = true
      let agentArr = []
      this.tableData = []
      let agentStatus = ''
      if (!this.agentemailid) { // for all agents
        agentArr = this.agentMaster.map(each => each.email)
      } else { // for selected agent
        agentArr.push(this.agentemailid)
      }
      if (this.agentestatus) { // If agent status is selected
        agentStatus = this.agentestatus
      }
      let getCase = {
        agentemails: agentArr,
        subdepartmentid: this.filter.subdepartmentid
      }
      Object.keys(getCase).forEach((key) => {
        if (getCase[key] === '' || getCase[key] === null || getCase[key] === undefined) {
          delete getCase[key]
        }
      })
      return http.post(`${CONSTANTS.API_URL}/api/emailr/getagentscasecountdetails`, getCase)
        .then((countDetails) => {
          if (countDetails && countDetails.length) {
            let tempAgents = []
            countDetails.forEach((crmAgent) => {
              tempAgents.push(crmAgent.agent)
              let ele = {
                handler: crmAgent.agent,
                allocated: crmAgent.allocated,
                inprocess: crmAgent.inprocess,
                closed: crmAgent.closed,
                spam: crmAgent.spam,
                status: '',
                statusduration: '',
                outcallcount: '',
                rnf: '',
                breaktime: '',
                ispaused: '',
                inqueue: '',
                userid: ''
              }
              this.tableData.push(ele)
            })
            tempAgents = {
              emails: tempAgents.toString(),
              location: this.filter.location.location
            }
            this.isLoadingRefresh = false
            return http.post(`${CONSTANTS.API_URL}/api/ivr/getagentwisebreakdetails`, tempAgents)
              .then((ivrApiResult) => {
                if (ivrApiResult && ivrApiResult[0]) {
                  this.tableData.forEach((crmAgent) => {
                    ivrApiResult.forEach((ivrAgent) => {
                      if (crmAgent.handler && ivrAgent.email && crmAgent.handler.toLowerCase() === ivrAgent.email.toLowerCase()) {
                        if (agentStatus) {
                          if (agentStatus && ivrAgent.agentstatus && agentStatus.toLowerCase() === ivrAgent.agentstatus.toLowerCase()) {
                            crmAgent.status = ivrAgent.agentstatus
                            crmAgent.statusduration = ivrAgent.statusduration
                            crmAgent.outcallcount = ivrAgent.outcallcount
                            crmAgent.rnf = ivrAgent.rnf
                            crmAgent.breaktime = ivrAgent.breaktime
                            crmAgent.ispaused = ivrAgent.ispaused
                            crmAgent.inqueue = ivrAgent.inqueue
                            crmAgent.userid = ''
                          }
                        } else {
                          crmAgent.status = ivrAgent.agentstatus
                          crmAgent.statusduration = ivrAgent.statusduration
                          crmAgent.outcallcount = ivrAgent.outcallcount
                          crmAgent.rnf = ivrAgent.rnf
                          crmAgent.breaktime = ivrAgent.breaktime
                          crmAgent.ispaused = ivrAgent.ispaused
                          crmAgent.inqueue = ivrAgent.inqueue
                          crmAgent.userid = ''
                        }
                        if (crmAgent.handler) {
                          this.agentMaster.forEach((agent) => {
                            if (crmAgent.handler.toLowerCase() === agent.email.toLowerCase()) {
                              crmAgent.userid = agent.userid
                            }
                          })
                        }
                      }
                    })
                  })
                } else {
                  return this.$buefy.toast.open({
                    message: `Error while getting IVR details`,
                    type: 'is-danger'
                  })
                }
                this.isLoadingRefresh = false
              })
              .catch((httpException) => {
                this.isLoadingRefresh = false
                return this.$buefy.toast.open({
                  message: `Error while getting IVR details`,
                  type: 'is-danger'
                })
              })
          } else {
            this.isLoadingRefresh = false
            return this.$buefy.toast.open({
              message: `Error while getting agent's count details`,
              type: 'is-danger'
            })
          }
        })
        .catch((httpException) => {
          this.isLoadingRefresh = false
          return this.$buefy.toast.open({
            message: httpException.message,
            type: 'is-danger'
          })
        })
    },
    getIvrReasonList: function (agent, userid, typeid, ispaused) {
      this.loadingComponent = this.$buefy.loading.open()
      if (ispaused === 1) {
        this.isPaused = 0
      } else {
        this.isPaused = 1
      }
      this.reasontype = typeid
      this.ivrAgent = agent
      this.ivrAgentUserid = userid
      this.reasontypeid = ''
      this.comment = ''
      this.isCommentboxDisable = true
      this.isCommentRequired = false
      if (ispaused === 0) { // get reason iff un paused & rnf
        return http.get(`${CONSTANTS.API_URL}/api/ivr/getivrreasonlist`, { reasontypeid: typeid })
          .then((result) => {
            this.loadingComponent.close()
            this.reasonList = []
            if (result && result.flag) {
              this.isReasonModal = true
              this.reasonList = result.data
            } else {
              return this.$buefy.toast.open({
                message: `No reason data found`,
                type: 'is-danger'
              })
            }
          })
          .catch((httpException) => {
            this.loadingComponent.close()
            return this.$buefy.toast.open({
              message: httpException.message,
              type: 'is-danger'
            })
          })
      } else {
        this.loadingComponent.close()
        this.submitReason()
      }
    },
    toggleReasonModal: function () {
      this.isReasonModal = !this.isReasonModal
    },
    submitReason: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()

        if (!this.reasontypeid && this.isPaused === 1) {
          this.isReasonModal = true
          this.loadingComponent.close()
        } else if (this.isCommentRequired && !this.comment && this.isPaused === 1) {
          this.loadingComponent.close()
          return this.$buefy.toast.open({
            message: `Please enter comment`,
            type: 'is-danger'
          })
        } else {
          let pauseObj = {
            email: this.ivrAgent,
            systemid: this.loggedUser.systemId,
            userid: this.ivrAgentUserid
          }
          let ivrObj = {
            reasonid: this.reasontypeid,
            reasontype: this.reasontype,
            comment: this.comment,
            ivragent: this.ivrAgent
          }
          Object.keys(ivrObj).forEach((key) => {
            if (!ivrObj[key]) {
              delete ivrObj[key]
            }
          })
          ivrObj.ispaused = this.isPaused
          let result = await http.post(`${CONSTANTS.API_URL}/api/ivr/submitivrreason`, ivrObj)
          if (result.status && result.body.flag) {
            let agent = this.ivrAgent
            if (result.body.data && result.body.data.extCode) {
              this.socketCall(ivrObj, result.body.data.extCode)
            }
            if (this.isPaused === 1 || this.reasontype === 2) { // CRM-end allocation pause iff paused or rnf
              let res = await http.post(`${CONSTANTS.API_URL}/api/usermgt/agentallocationpause`, pauseObj)
              this.loadingComponent.close()
              if (res && res.status) {
                if (this.reasontype === 2) {
                  this.reset()
                  await setTimeout(async function () {
                    await this.getMainData()
                  }.bind(this), 1000)
                  return this.$buefy.toast.open({
                    message: `Agent ${agent} R&F success`,
                    type: 'is-success'
                  })
                } else {
                  this.reset()
                  return this.$buefy.toast.open({
                    message: `Agent ${agent} paused successfully`,
                    type: 'is-success'
                  })
                }
              } else {
                this.loadingComponent.close()
                return this.$buefy.toast.open({
                  message: `Something went wrong while allocation pause`,
                  type: 'is-danger'
                })
              }
            } else {
              this.loadingComponent.close()
              this.reset()
              await setTimeout(async function () {
                await this.getMainData()
              }.bind(this), 1000)
              return this.$buefy.toast.open({
                message: `Agent ${agent} un paused successfully`,
                type: 'is-success'
              })
            }
          } else {
            this.loadingComponent.close()
            return this.$buefy.toast.open({
              message: `Something went wrong while allocation pause`,
              type: 'is-danger'
            })
          }
        }
      } catch (e) {
        this.loadingComponent.close()
        return this.$buefy.toast.open({
          message: `Something went wrong while allocation pause`,
          type: 'is-danger'
        })
      }
    },
    socketCall: function (ivrObj, extCode) {
      var socket = io.connect(`${CONSTANTS.IVR_SOCKET}:8888`, {
        reconnect: true
      })
      socket.on('connect', function (res) {
        var x = {
          dataArr: {
            extCode: extCode,
            msg: 'this is sample notification',
            reason: ivrObj.reasonid,
            usr: ivrObj.ivragent,
            connemt: ivrObj.comment
          }
        }
        socket.emit('postAlertData', x)
        return true
      })
    },
    toggleCommentbox: function () {
      this.comment = ''
      this.isCommentboxDisable = true
      this.isCommentRequired = false
      if (this.reasontypeid) {
        this.reasonList.forEach((reason) => {
          if (this.reasontypeid === reason.ReasonID) {
            if (reason.CommentType === '3') { // comment mandatory
              this.isCommentboxDisable = false
              this.isCommentRequired = true
            } else if (reason.CommentType === '2') { // comment optional
              this.isCommentboxDisable = false
              this.isCommentRequired = false
            } else { // no comment
              this.isCommentboxDisable = true
            }
          }
        })
      }
    },
    checkHour: function (timeStr) {
      if ((moment.duration(timeStr).asMinutes()) > 59) {
        return true
      } else {
        return false
      }
    },
    checkMins: function (timeStr) {
      if ((moment.duration(timeStr).asMinutes()) > 9) {
        return '#ff3300'
      } else {
        return '#e6b800'
      }
    },
    reset: function () {
      this.reasontype = ''
      this.ivrAgent = ''
      this.ivrAgentUserid = ''
      this.isPaused = ''
      this.reasontypeid = ''
      this.comment = ''
      this.isReasonModal = false
    },
    getAllActiveLocations:async function () {
      this.locations = []
      this.filter.location = ''
        try {
          let res = await http.get(`${CONSTANTS.API_URL}/api/locations`)
          if (res.data.rows && res.data.rows.length) {
            res.data.rows.forEach((each)=>{
              if (this.loggedUser.role === 'teamlead') {
                if (this.loggedUser.location === each.location) {
                  this.filter.location = {
                    location:each.location,
                    locationid:each.locationid
                  }
                }
              }
              this.locations.push({
                location:each.location,
                locationid:each.locationid
              })
            })
          }
        } catch (e) {
          console.log('Error in get locations',e);
        }
    }
  }
}
</script>

<style lang="css" scoped>
.colWidth {
  word-break:break-all;
}
.text-red {
  color: red;
}
.label-padding {
  padding: 0px 0px 0px 7%;
}
.count-padding {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/components/emailr/EmailrUserDashboard.vue?86d7b526